import React from 'react';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Impressum - CRM Kraft | Justus Kraft" description="Impressum und Kontaktinformationen für CRM Kraft - Justus Kraft." keywords="impressum, CRM Kraft, Justus Kraft, Kontakt" ogType="website" data-id="element-430" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-431">
        <div className="max-w-4xl mx-auto" data-id="element-432">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-433">
            Impressum
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-434">
            <section className="mb-8" data-id="element-435">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-436">
                Adresse
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-437">
                CRM Kraft LLC
                <br data-id="element-438" />
                2880 West Oakland Park Boulevard
                <br data-id="element-439" />
                33311 Florida
                <br data-id="element-440" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-441">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-442">
                Kontakt
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-443">
                Telefon: +4915735999071
                <br data-id="element-444" />
                E-Mail: justus@crm-kraft.de
              </p>
            </section>

            <section className="mb-8" data-id="element-445">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-446">
                EU-Streitschlichtung
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-447">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-448">
                  https://ec.europa.eu/consumers/odr/
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section className="mb-8" data-id="element-449">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-450">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-451">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}